/**
 * Quote Status Enum
 * Defines the different statuses a quote can have
 */
export enum QuoteStatusEnum {
    "Pending" = 1,
    "Approved" = 2,
    "Rejected" = 3,
    "Deleted" = 4,
    "Expired" = 5,
    "Flagged" = 6,
    "Used" = 7,
    "Cancelled" = 8,
    "Completed" = 9,
    "Refunded" = 10,
    "Responded" = 11,
    "Active" = 12,
    "InActive" = 13,
}

/**
 * Purchase Quote Type Enum
 * Defines the different types of quote purchases
 */
export enum PurchaseQuoteTypeEnum {
    "Credit" = 1,
    "Purchase" = 2,
    "Assign" = 3,
    "Promotional" = 4,
}

